import api from './api'
import CallHelper from '@/helpers/call.helper'

class TransactionService {
    async get(params = {}) {
        return CallHelper.getDataRecursive('/transaction', params, (data, response) => {
            if(data.length) {
                data = [...data, ...response.data.transactions]
            } else {
                data = response.data.transactions
            }

            return data
        },)
    }

    async getTransactionType() {
        return api.get('/enum/transaction-type')
    }

    async getInstance(uuid) {
        return api.get('/transaction/' + uuid)
    }

    async create(transaction) {
        return api.post('/transaction', transaction)
        .then(response => response.data);
    }

    async modify(uuid, transaction) {
        return api.patch('/transaction/' + uuid, transaction)
            .then(response => {
                return response.data
            })
    }

    async delete(transaction) {
        return api.delete('/transaction/' + transaction.uuid)
            .then(response => response.data);
    }
}

export default new TransactionService();
